import axios from 'axios';

import { RenterDto } from '@tallo/renter';

import { RenterScreeningDto } from '../interfaces/renter-screening-dto.interface';

class RenterProfileService {
  async getProfileById(renterId: string): Promise<RenterDto> {
    const response = await axios.get<RenterDto>(`renter/${renterId}`);
    return response.data as RenterDto;
  }

  async getProfileByEmail(email: string): Promise<RenterDto> {
    const response = await axios.get<RenterDto>(`renter/by-email/${email}`);
    return response.data as RenterDto;
  }

  async getRenterScreening(screeningId: string): Promise<RenterScreeningDto> {
    const response = await axios.get<RenterScreeningDto>(`renter-screening/${screeningId}`);
    return response.data as RenterScreeningDto;
  }
}

export default new RenterProfileService();
